export default class ReportesProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }

    //====================REPORTES ACTUALES=====================================
    
    promocion(params) {
        return this.axios.post(this.url + '/reportes', params);
    }
    promocionPdf(params) {
        return this.axios.post(this.url + '/reportes/promocionPdf', params);
    }
    matricula(params) {
        return this.axios.post(this.url + '/reportes/matricula', params);
    }
    matriculaPdf(params) {
        return this.axios.post(this.url + '/reportes/matriculaPdf', params);
    }
    libretas(params) {
        return this.axios.post(this.url + '/reportes/libretas/', params);
    }
    juntas(params) {
        return this.axios.post(this.url + '/reportes/juntas/', params);
    }
    juntasIndividual(params) {
        return this.axios.post(this.url + '/reportes/juntasIndividual/', params);
    }
    juntasFinal(params) {
        return this.axios.post(this.url + '/reportes/juntasFinal/', params);
    }
    informe(params) {
        return this.axios.post(this.url + '/reportes/informe/', params);
    }
    parcial(params) {
        return this.axios.post(this.url + '/reportes/parcial/', params);
    }
    quimestral(params) {
        return this.axios.post(this.url + '/reportes/quimestral/', params);
    }
    anual(params) {
        return this.axios.post(this.url + '/reportes/anual/', params);
    }
    final(params) {
        return this.axios.post(this.url + '/reportes/final/', params);
    }
    nomina() {
        return this.axios.get(this.url + `/reportes/nomina`);
    }
    nominaDocentes() {
        return this.axios.get(this.url + `/reportes/nominaDocentes`);
    }
    ambitos(params) {
        return this.axios.post(this.url + '/reportes/ambitos/', params);
    }
    destrezas(params) {
        return this.axios.post(this.url + '/reportes/destrezas/', params);
    }
    actasFin(params) {
        return this.axios.post(this.url + '/reportes/actasFin/', params);
    }

    //====================REPORTES DEL PERIODO 2023=====================================
     
    getById2023(id) {
        return this.axios.get(this.url + `/rep2023/${id}`);
    }
    promocion2023(params) {
        return this.axios.post(this.url + '/rep2023', params);
    }
    matricula2023(params) {
        return this.axios.post(this.url + '/rep2023/matricula/', params);
    }
    libretas2023(params) {
        return this.axios.post(this.url + '/rep2023/libretas/', params);
    }
    juntas2023(params) {
        return this.axios.post(this.url + '/rep2023/juntas/', params);
    }
    informe2023(params) {
        return this.axios.post(this.url + '/rep2023/informe/', params);
    }
    parcial2023(params) {
        return this.axios.post(this.url + '/rep2023/parcial/', params);
    }
    quimestral2023(params) {
        return this.axios.post(this.url + '/rep2023/quimestral/', params);
    }
    anual2023(params) {
        return this.axios.post(this.url + '/rep2023/anual/', params);
    }
    final2023(params) {
        return this.axios.post(this.url + '/rep2023/final/', params);
    }
    ambitos2023(params) {
        return this.axios.post(this.url + '/rep2023/ambitos/', params);
    }
    destrezas2023(params) {
        return this.axios.post(this.url + '/rep2023/destrezas/', params);
    }
}

